import { RoutineType } from '../domain/db/RoutineTypeDB'
import { NumericDB } from '../domain/db/NumericDB'
import { WeekdaysDB } from '../domain/db/WeekdaysDB'
import moment from 'moment'

export const getTitleByType = (sequence: number, type: RoutineType) => {
  const routineTypeDB = (type === RoutineType.NUMERIC) ? NumericDB() : WeekdaysDB()
  return routineTypeDB.find(routineType => routineType.value === sequence)
}

export const setLimitCharacter = (name: string = '', limit: number = 22) => {
  if (name.length > limit) {
    return `${name.substring(0, limit)}...`
  }
  return name
}

export const getFirstLetter = (name: string) => {
  return name.substring(0, 1)
}

export const removeAccent = (data: string) => {
  return data.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
}

export const diffDays = (date: Date | undefined, limit = 7) => {
  if (date) {
    const currentDate = new Date()
    const expirationAt = new Date(date)
    expirationAt.setDate(expirationAt.getDate() + limit)
    return expirationAt.getDate() - currentDate.getDate()
  }
  return -1
}

export const diffDaysBetweenDates = (date: Date | undefined | null, current: Date = new Date()) => {
  if (!date) return -1
  moment()
  const currentDate = new Date(current)
  const differenceInMs = date.getTime() - currentDate.getTime()
  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24))
  return differenceInDays
}
